import axios from '../axios/index';

const endpoints = {
  getCountEvents: () => axios.get('booking-users-count'),
};

export default endpoints;
